import { baseApi } from "@/shared/api";
import type { AuditListResponse, AuditQueryParams } from "../types";

export function buildProjectAuditSearchParams(params: AuditQueryParams): URLSearchParams {
  const searchParams = new URLSearchParams();
  searchParams.set("module", "projects");
  if (params.page) searchParams.set("page", String(params.page));
  if (params.page_size) searchParams.set("page_size", String(params.page_size));
  if (params.action) searchParams.set("action", params.action);
  if (params.target_id) searchParams.set("target_id", String(params.target_id));
  if (params.target_type) searchParams.set("target_type", params.target_type);
  if (params.project !== undefined) searchParams.set("project", String(params.project));
  if (params.date_from) searchParams.set("date_from", params.date_from);
  if (params.date_to) searchParams.set("date_to", params.date_to);
  return searchParams;
}

export const auditApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProjectAudit: builder.query<AuditListResponse, AuditQueryParams>({
      query: (params) => ({
        url: `/api/audit/?${buildProjectAuditSearchParams(params).toString()}`,
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: [{ type: "AuditEntries", id: "PROJECT_LIST" }],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetProjectAuditQuery, useLazyGetProjectAuditQuery } = auditApi;
